import { render, staticRenderFns } from "./PanelLogin.vue?vue&type=template&id=63ddec69&"
import script from "./PanelLogin.vue?vue&type=script&lang=js&"
export * from "./PanelLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports